export const sortCategories = (categories) => {
  const visible = []
  for (let category of categories) {
    if (category.showInList) visible.push(category)
  }
  return visible.sort((a, b) => (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0))
}
